import EnterpriseConfigDemo from "@/components/EnterpriseConfigDemo";

export default function EnterpriseConfigDemoPage() {
  return <EnterpriseConfigDemo />;
}
